/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Invert from 'astro/react/map/util/invert';
import Fortified from 'astro/react/map/util/fortified';

import Resource from 'astro/react/icon/resource';


export default ({ zone, grid }) =>
{
  const type = zone.getCass().getResource().type;

  const size = grid.getGeneralHex().getEntitySize();

  return <Resource center size = {size} type = {type} />;
}
